import Localization from '../localization/LocalizationManager'
import { enumToList } from '../utils/converters'

enum CommonFilterType {
  Category = 'category',
  Type = 'type',
  Status = 'status',
  Location = 'location',
  Equipment = 'equipment',
  Company = 'company',
  ResponsibleContact = 'responsibleContact',
}

enum ProjectFilterType {
  Project = 'project',
}

enum AttachmentFilterType {
  Attachment = 'attachment',
}

export type LogisticsFilterType =
  | CommonFilterType
  | ProjectFilterType
  | AttachmentFilterType

export const LogisticsFilterType = {
  ...CommonFilterType,
  ...ProjectFilterType,
  ...AttachmentFilterType,
}

export const FormsFilterType = {
  ...CommonFilterType,
  ...AttachmentFilterType,
  ...ProjectFilterType,
}

export const getLogisticsFilterTypeCaption = (type: LogisticsFilterType) => {
  switch (type) {
    case LogisticsFilterType.Status:
      return Localization.translator.workflowStatus
    case LogisticsFilterType.Location:
      return Localization.translator.location
    case LogisticsFilterType.Equipment:
      return Localization.translator.equipment
    case LogisticsFilterType.Company:
      return Localization.translator.company
    case LogisticsFilterType.Type:
      return Localization.translator.workflowType
    case LogisticsFilterType.ResponsibleContact:
      return Localization.translator.responsibleContact
    case LogisticsFilterType.Category:
      return Localization.translator.workflowCategory
    case LogisticsFilterType.Project:
      return Localization.translator.project
    case LogisticsFilterType.Attachment:
      return Localization.translator.fileType
    default:
      throw new Error(type + ' is unhandled')
  }
}

export const formsFilterTypes = enumToList(FormsFilterType)
